import { createActions } from 'redux-actions';

const actions = createActions({
  MACHINE_STATE: {
    MACHINE: {
      SET: undefined
    }
  }
});

export default actions;
